import { callSettingType } from "./callSetting.type";

const initialState = {
  callSettingsList: [],
  callSettings: {},
  allVoices: {},
};

function CallSettingReducer(state = initialState, action) {
  switch (action.type) {
    case callSettingType.GET_ALL_CALL_SETTING_DATA: {
      return { ...state, callSettingsList: action.payload };
    }
    case callSettingType.GET_CALL_SETTING_DATA: {
      return { ...state, callSettings: action.payload?.[0] };
    }
    case callSettingType.GET_ALL_VOICES_DATA: {
      return {
        ...state,
        allVoices: {
          ...state.allVoices,
          ...action.payload,
        },
      };
    }
    case callSettingType.CLEAR_CALL_SETTING: {
      return { ...initialState };
    }

    default:
      return state;
  }
}

export default CallSettingReducer;
